<input v-model="data.model" :type="data.type" :id="data.id" :name="data.id" :value="data.value">